import React, { FC, Suspense, lazy } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { NavbarV2 } from '@bitcoin-portal/navbar';

import { appLocales } from '../../i18n';

import Header from './Header';
import Wallet from './Wallet';
import { BlueBar, StyledParagraph } from './styled';

import footerContent from './footerContent.json';

interface Props {
  data: Queries.HomeQueryQuery;
  locale: string;
  provider?: string;
}

const Footer = lazy(() => import('@bitcoin-portal/footer'));

const UnitedKingdom: FC<Props> = ({ data, locale, provider }) => {
  const { file } = data;

  return (
    <>
      <NavbarV2 locale={locale} />
      <main>
        <BlueBar>
          <LazyLoadImage src="/images/icinfo.png" alt="Info" />
          <StyledParagraph>
            {`Don't invest unless you're prepared to lose all the money you invest.
            This is a high-risk investment and you should not expect to be
            protected if something goes wrong. `}
            <a href="https://srt.bitcoin.com/uk-fca-risk-summary">
              Take 2 mins to learn more.
            </a>
          </StyledParagraph>
        </BlueBar>
        <Header header={file?.childJson?.header || null} provider={provider} />
        <Wallet wallet={file?.childJson?.wallet || null} />
      </main>

      <Suspense>
        <Footer
          locale={locale}
          localeList={Object.keys(appLocales)}
          links={footerContent.links}
          legal={footerContent.legal}
        />
      </Suspense>
    </>
  );
};

export default UnitedKingdom;
